<section>
    <div class="row-items">
        <div class="label-group">
            <div class="label">{{label}}</div>
            <span *ngIf="badge" class="row-badge">{{ badge }}</span>
        </div>
        <span *ngIf="content" class="value" [innerHTML]="sanitizedContent"></span>
        <span class="price">{{price}}</span>
    </div>
</section>
